<template>
  <div class="page-content">
    <el-breadcrumb separator-class="nu">
      <el-breadcrumb-item
        v-for="(item, index) in nvItems"
        :key="index"
        @click.native="breadClick(index)"
        :class="
          (!datas || datas.length == 0) && index == nvItems.length - 1
            ? 'nv-item-end'
            : 'nv-item'
        "
        >{{ lang == "EN" ? item.name : item.enName }}</el-breadcrumb-item
      >
      <el-breadcrumb-item class="nv-item-end" v-if="datas[activeItem]">{{
        lang == "EN"
          ? pageName == "news"
            ? datas[activeItem].name
            : datas[activeItem].title
          : pageName == "news"
          ? datas[activeItem].enName
          : datas[activeItem].enTitle
      }}</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="margin-top: 40px" class="page-main">
      <div class="menu">
        <MenuItem
          v-for="(item, index) in datas"
          :key="index"
          item-class="my-menu-item"
          :class="index == activeItem ? 'my-menu-item-active' : ''"
          @click.native="menuItemClick(index)"
          :name="
            lang == 'EN'
              ? pageName == 'news'
                ? item.name
                : item.title
              : pageName == 'news'
              ? item.enName
              : item.enTitle
          "
        />
      </div>
      <PageContent
        :content="content"
        :show-map="showMap"
        :chart-data="chartData"
        :chart-setting="chartSetting"
        :show-leave-word="showLeaveWord"
        :lang="lang"
        :page-name="pageName"
        :news="news"
        :news-title="newsTitle"
        ref="pageContent"
      />
    </div>
  </div>
</template>

<script>
import MenuItem from "@/components/MenuItem.vue";
import PageContent from "@/components/PageContent.vue";
import { getNews } from "@/api/data.js";
let isShowNewContent = false;
export default {
  props: {
    nvItems: Array,
    datas: Array,
    lang: String,
    pageName: String,
  },
  components: {
    MenuItem,
    PageContent,
  },
  data() {
    return {
      showMap: false,
      activeItem: 0,
      content: "",
      chartData: null,
      chartSetting: null,
      showLeaveWord: false,
      news: [],
      newsTitle: "",
      activeNews: undefined,
    };
  },

  watch: {
    lang() {
      console.log("lang change --------");
      if (this.lang == "EN") {
        this.content = this.datas[this.activeItem].content;
        this.newsTitle = this.datas[this.activeItem].name;
      } else {
        this.content = this.datas[this.activeItem].enContent;
        this.newsTitle = this.datas[this.activeItem].enName;
      }
    },
    datas() {
      console.log("data change --------");
      this.updateView();
    },
  },

  mounted() {
    // this.setActiveNews(this.activeNews);
  },
  methods: {
    updateView(data) {
      console.log(data);
      this.showLeaveWord = this.datas[this.activeItem].title == "联系我们";
      try {
        if (this.datas[this.activeItem].chartData) {
          this.chartData = JSON.parse(this.datas[this.activeItem].chartData);
          this.showMap = this.datas[this.activeItem].showMap;
        }
      } catch (e) {
        console.log(e);
      }
      if (this.pageName == "news") {
        this.getNews(this.datas[this.activeItem].id, data);
      } else {
        if (this.lang == "EN") {
          this.content = this.datas[this.activeItem].content;
        } else {
          this.content = this.datas[this.activeItem].enContent;
        }
      }
    },
    getNews(id, showNews) {
      let that = this;
      isShowNewContent = showNews;
      getNews({
        typeId: id,
      })
        .then((res) => {
          console.log(res);
          if (res.status == 200 && res.data.code == 200) {
            if (isShowNewContent) {
              that.setActiveNews(that.activeNews);
              isShowNewContent = false;
              return;
            }
            that.news = res.data.data;
            if (this.lang == "EN") {
              that.newsTitle = that.datas[that.activeItem].name;
            } else {
              that.newsTitle = that.datas[that.activeItem].enName;
            }
          } else {
            that.newsTitle = "";
            that.news = [];
          }
        })
        .catch((res) => {
          console.log(res);
          that.newsTitle = "";
          that.news = [];
        });
    },
    breadClick(index) {
      if (index == 1) {
        this.menuItemClick(0);
      } else if (index == 0) {
        this.$emit("homeClick", this.nvItems[index].name);
      }
    },
    setActiveItem(id) {
      for (let i = 0; i < this.datas.length; i++) {
        if (this.datas[i].id == id) {
          this.activeItem = i;
          this.showLeaveWord = this.datas[i].title == "联系我们";
          try {
            this.chartData = JSON.parse(this.datas[i].chartData);
            this.showMap = this.datas[i].showMap;
          } catch (e) {
            console.log(e);
          }
          if (this.lang == "EN") {
            this.content = this.datas[i].content;
          } else {
            this.content = this.datas[i].enContent;
          }
          break;
        }
      }
    },

    setNews(news) {
      this.activeNews = news;
      console.log("set news -----------");
      this.setActiveNews(news);
    },

    setActiveNews(news) {
      let datas = this.datas;
      for (let i = 0; i < datas.length; i++) {
        if (datas[i].id == news.groupId) {
          this.activeItem = i;
        }
      }
      this.$refs.pageContent.setNews(news);
    },

    menuItemClick(e) {
      this.activeItem = parseInt(e);
      this.showLeaveWord = this.datas[this.activeItem].title == "联系我们";
      try {
        this.chartData = JSON.parse(this.datas[this.activeItem].chartData);
        this.showMap = this.datas[this.activeItem].showMap;
      } catch (e) {
        console.log(e);
      }

      if (this.pageName == "news") {
        this.getNews(this.datas[this.activeItem].id);
      }

      if (this.lang == "EN") {
        this.content = this.datas[this.activeItem].content;
      } else {
        this.content = this.datas[this.activeItem].enContent;
      }
    },
  },
};
</script>

<style scoped>
.page-main {
  display: flex;
}

.my-menu-item {
}

.my-menu-item:hover {
  background-color: #409eff;
  color: #f2f2f2;
}

.my-menu-item-active {
  background-color: #409eff;
  color: #f2f2f2;
}

.nv-item {
  background: url(../assets/bg-mianbao1.jpg) no-repeat right center #f2f2f2;
  padding: 20px;
  background-size: 24px 60px;
  cursor: pointer;
}

.nv-item-end {
  background: url(../assets/bg-mianbao.jpg) no-repeat right center #f2f2f2;
  padding: 20px;
  padding-right: 20px;
  background-size: 24px 60px;
}
.menu {
  min-width: 240px;
}

.nv-item-end:nth-child(1) {
  color: #303133;
  font-weight: 700;
}
</style>
